import { render } from "./Header.vue?vue&type=template&id=46bc3dbe&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=46bc3dbe&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bc3dbe"]])

export default __exports__